function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ConfigProvider from '../../config-provider';
import { obj } from '../../util';
import Icon from '../../icon';
/**
 * Button.Icon
 */

var IconButton = /*#__PURE__*/function (_Component) {
  _inherits(IconButton, _Component);

  var _super = _createSuper(IconButton);

  function IconButton() {
    var _this;

    _classCallCheck(this, IconButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onClick", function (e) {
      if (_this.props.disabled) {
        e.preventDefault();
        return;
      }

      _this.props.onClick(e);
    });

    return _this;
  }

  _createClass(IconButton, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          prefix = _this$props.prefix,
          className = _this$props.className,
          size = _this$props.size,
          htmlType = _this$props.htmlType,
          component = _this$props.component,
          type = _this$props.type,
          name = _this$props.name,
          color = _this$props.color,
          disabled = _this$props.disabled,
          children = _this$props.children;
      var groupCls = classNames("".concat(prefix, "iconbtn"), (_classNames = {}, _defineProperty(_classNames, "".concat(prefix, "iconbtn-").concat(type), type), _defineProperty(_classNames, "".concat(prefix, "iconbtn-").concat(size), size), _defineProperty(_classNames, "".concat(prefix, "iconbtn-").concat(color), color), _defineProperty(_classNames, "disabled", disabled), _defineProperty(_classNames, className, className), _classNames));
      var TagName = component;

      var tagAttrs = _objectSpread({}, this.props, {
        type: htmlType,
        className: groupCls
      });

      if (TagName !== 'button') {
        delete tagAttrs.type;
      }

      return /*#__PURE__*/React.createElement(TagName, _extends({}, obj.pickAttrs(tagAttrs), {
        onClick: this.onClick
      }), name ? /*#__PURE__*/React.createElement(Icon, {
        type: name,
        size: size
      }) : children);
    }
  }]);

  return IconButton;
}(Component);

_defineProperty(IconButton, "propTypes", {
  prefix: PropTypes.string,

  /**
   * 图标按钮的图标名字
   */
  name: PropTypes.string,

  /**
   * 图标按钮的图标类型
   */
  type: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * 当 component = 'button' 时，设置 button 标签的 type 值
   */
  htmlType: PropTypes.oneOf(['submit', 'reset', 'button']),

  /**
   * 设置标签类型
   */
  component: PropTypes.oneOf(['button', 'a', 'div', 'span']),

  /**
   * 统一设置 Button 组件的按钮大小
   */
  size: PropTypes.oneOf(['medium', 'large']),

  /**
   * 图标按钮的图标颜色
   */
  color: PropTypes.oneOf(['default', 'gray']),

  /**
   * 是否禁用
   */
  disabled: PropTypes.bool,

  /**
   * 点击按钮的回调
   * @param {Object} e Event Object
   */
  onClick: PropTypes.func,
  className: PropTypes.string
});

_defineProperty(IconButton, "defaultProps", {
  prefix: 'next-',
  size: 'medium',
  htmlType: 'button',
  component: 'button',
  type: 'primary',
  color: 'default',
  disabled: false,
  onClick: function onClick() {}
});

export default ConfigProvider.config(IconButton);